import React, { useState } from 'react'
import Modal from 'react-bootstrap-modal'
import StringMatch from './matches/string-match'
import MultiMatch from './matches/multi-match'

const Filters = ({filters, onClose, onApply}) => {
  const [tmpFilters, setTmpFilters] = useState(filters)

  const columnsValues = [['name', 'Company'], ['status', 'Status']]
  const typeValues    = ['and', 'or']

  const addNewRow = () => {
    const type = tmpFilters.length ? 'and' : null
    setTmpFilters([...tmpFilters, {type: type, column: columnsValues[0][0]}])
  }

  const updateRow = (index, data) => {
    setTmpFilters([
      ...tmpFilters.slice(0, index),
      data,
      ...tmpFilters.slice(index + 1, tmpFilters.length)
    ])
  }

  const removeRow = (index) => {
    const result = [...tmpFilters.slice(0, index), ...tmpFilters.slice(index + 1, tmpFilters.length)]
    if (index == 0 && result.length) result[0].type = null
    setTmpFilters(result)
  }

  const transformRow = (index, value) => {
    setTmpFilters([
      ...tmpFilters.slice(0, index),
      {type: tmpFilters[index].type, column: value},
      ...tmpFilters.slice(index + 1, tmpFilters.length)
    ])
  }

  const displayFilters = () => {
    return tmpFilters.map((value, i) => {
      switch(value.column) {
        case 'name':
          return (
            <StringMatch
              key={i}
              data={value}
              types={typeValues}
              columns={columnsValues}
              onRemove={() => removeRow(i)}
              onChange={data => updateRow(i, data)}
              onTransform={column => transformRow(i, column)}
            />
          )
        case 'status':
          return (
            <MultiMatch
              key={i}
              data={value}
              types={typeValues}
              columns={columnsValues}
              values={[['production', 'Existing'], ['demo', 'Potential']]}
              onRemove={() => removeRow(i)}
              onChange={data => updateRow(i, data)}
              onTransform={column => transformRow(i, column)}
            />
          )
      }
    })
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose} className='clients-filter'>
      <Modal.Header closeButton>
        <Modal.Title>Filters</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='filters'>
          <div className='filters__list'>
            {displayFilters()}
          </div>
          <div className='filters__actions'>
            <div className='add-condition' onClick={addNewRow}>+ Add condition</div>
            <div className='buttons'>
              <button className='btn btn-default' onClick={onClose}>Cancel</button>
              <button className='btn btn-info' onClick={() => onApply(tmpFilters)}>Apply</button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default Filters
